"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ProvisioningType = exports.SetupStatus = exports.FulfillmentStatus = exports.RelationPermissionType = exports.Status = exports.CoBrandPartner = exports.Action = void 0;
var Action;
(function (Action) {
    Action["STATUS_UPDATE"] = "STATUS_UPDATE";
    Action["CREATED"] = "CREATED";
    Action["PRODUCT_CHANGE"] = "PRODUCT_CHANGE";
    Action["FULFILLMENT_CHANGE"] = "FULFILLMENT_CHANGE";
    Action["DELEGATE_CHANGE"] = "DELEGATE_CHANGE";
    Action["SERVICE_AREA_CHANGE"] = "SERVICE_AREA_CHANGE";
    Action["REPLACED"] = "REPLACED";
    Action["EFFECTIVE_DATE_CHANGE"] = "EFFECTIVE_DATE_CHANGE";
    Action["OWNER_CHANGE"] = "OWNER_CHANGE";
    Action["SETUP_CHANGE"] = "SETUP_CHANGE";
    Action["MIGRATION_UPDATE"] = "MIGRATION_UPDATE";
    Action["DELEGATE_REPLACE"] = "DELEGATE_REPLACE";
    Action["CONTRACT_CHANGE"] = "CONTRACT_CHANGE";
    Action["PROVISIONING_TYPE_CHANGE"] = "PROVISIONING_TYPE_CHANGE";
    Action["DELETED"] = "DELETED";
    Action["PRODUCT_INFO_CHANGE"] = "PRODUCT_INFO_CHANGE";
})(Action = exports.Action || (exports.Action = {}));
var CoBrandPartner;
(function (CoBrandPartner) {
    CoBrandPartner["PRIMERICA"] = "PRIMERICA";
    CoBrandPartner["SOFI"] = "SOFI";
    CoBrandPartner["NEWITY"] = "NEWITY";
})(CoBrandPartner = exports.CoBrandPartner || (exports.CoBrandPartner = {}));
var Status;
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["CANCELLED"] = "CANCELLED";
    Status["SUSPENDED"] = "SUSPENDED";
})(Status = exports.Status || (exports.Status = {}));
var RelationPermissionType;
(function (RelationPermissionType) {
    RelationPermissionType["PRIMARY"] = "PRIMARY";
    RelationPermissionType["SPOUSE"] = "SPOUSE";
    RelationPermissionType["DEPENDENT"] = "DEPENDENT";
    RelationPermissionType["NORMAL_USER"] = "NORMAL_USER";
    RelationPermissionType["OWNER"] = "OWNER";
    RelationPermissionType["CO_OWNER"] = "CO_OWNER";
    RelationPermissionType["SECONDARY"] = "SECONDARY";
    RelationPermissionType["TERTIARY"] = "TERTIARY";
    RelationPermissionType["ELDER"] = "ELDER";
})(RelationPermissionType = exports.RelationPermissionType || (exports.RelationPermissionType = {}));
var FulfillmentStatus;
(function (FulfillmentStatus) {
    FulfillmentStatus["Fulfilled"] = "Fulfilled";
    FulfillmentStatus["NotFulfilled"] = "NotFulfilled";
    FulfillmentStatus["PendingChange"] = "PendingChange";
    FulfillmentStatus["PendingCreate"] = "PendingCreate";
})(FulfillmentStatus = exports.FulfillmentStatus || (exports.FulfillmentStatus = {}));
var SetupStatus;
(function (SetupStatus) {
    SetupStatus["SETUP"] = "SETUP";
    SetupStatus["NOT_SETUP"] = "NOT_SETUP";
})(SetupStatus = exports.SetupStatus || (exports.SetupStatus = {}));
var ProvisioningType;
(function (ProvisioningType) {
    ProvisioningType["IMMEDIATE"] = "IMMEDIATE";
    ProvisioningType["ON_FIRST_USE"] = "ON_FIRST_USE";
})(ProvisioningType = exports.ProvisioningType || (exports.ProvisioningType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://entitlements.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Entitlements API
 * @version v1
 * @baseUrl https://entitlements.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlementsAll
             * @request GET:/v1/identities/{identityId}/entitlements
             * @secure
             */
            entitlementsGetEntitlementsAll: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCreateEntitlement
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements
             * @secure
             */
            entitlementsCreateEntitlement: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlements
             * @request GET:/v1/users/{identityId}/entitlements
             * @secure
             */
            entitlementsGetEntitlements: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCreateEntitlement2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements
             * @secure
             */
            entitlementsCreateEntitlement2: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlement
             * @request GET:/v1/identities/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsGetEntitlement: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateEntitlement
             * @summary Machine JWT Only
             * @request PUT:/v1/identities/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsUpdateEntitlement: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsDeleteEntitlement
             * @summary Machine JWT Only
             * @request DELETE:/v1/identities/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsDeleteEntitlement: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsGetEntitlement2
             * @request GET:/v1/users/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsGetEntitlement2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateEntitlement2
             * @summary Machine JWT Only
             * @request PUT:/v1/users/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsUpdateEntitlement2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsDeleteEntitlement2
             * @summary Machine JWT Only
             * @request DELETE:/v1/users/{identityId}/entitlements/{entitlementId}
             * @secure
             */
            entitlementsDeleteEntitlement2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}`, method: 'DELETE', secure: true }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProduct
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeProduct
             * @secure
             */
            entitlementsUpdateProduct: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProduct2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeProduct
             * @secure
             */
            entitlementsUpdateProduct2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeProduct`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProductInfo
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/products/changeProductInfo
             * @secure
             */
            entitlementsUpdateProductInfo: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/products/changeProductInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsUpdateProductInfo2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/products/changeProductInfo
             * @secure
             */
            entitlementsUpdateProductInfo2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/products/changeProductInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsActivateStatus
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/activate
             * @secure
             */
            entitlementsActivateStatus: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsActivateStatus2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/activate
             * @secure
             */
            entitlementsActivateStatus2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/activate`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsSuspendStatus
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/suspend
             * @secure
             */
            entitlementsSuspendStatus: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsSuspendStatus2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/suspend
             * @secure
             */
            entitlementsSuspendStatus2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/suspend`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCancelStatus
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/cancel
             * @secure
             */
            entitlementsCancelStatus: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/cancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsCancelStatus2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/cancel
             * @secure
             */
            entitlementsCancelStatus2: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/cancel`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/addDelegates
             * @secure
             */
            entitlementsAddDelegates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/addDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/addDelegates
             * @secure
             */
            entitlementsAddDelegates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/addDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates3
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/addAuthorizedUsers
             * @secure
             */
            entitlementsAddDelegates3: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/addAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddDelegates4
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/addAuthorizedUsers
             * @secure
             */
            entitlementsAddDelegates4: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/addAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/removeDelegates
             * @secure
             */
            entitlementsRemoveDelegates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/removeDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates2
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/removeDelegates
             * @secure
             */
            entitlementsRemoveDelegates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/removeDelegates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates3
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/removeAuthorizedUsers
             * @secure
             */
            entitlementsRemoveDelegates3: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/removeAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Entitlements
             * @name EntitlementsRemoveDelegates4
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/removeAuthorizedUsers
             * @secure
             */
            entitlementsRemoveDelegates4: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/removeAuthorizedUsers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/replaceDelegate
             * @secure
             */
            entitlementsReplaceDelegates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/replaceDelegate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/replaceDelegate
             * @secure
             */
            entitlementsReplaceDelegates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/replaceDelegate`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates3
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/replaceAuthorizedUser
             * @secure
             */
            entitlementsReplaceDelegates3: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/replaceAuthorizedUser`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsReplaceDelegates4
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/replaceAuthorizedUser
             * @secure
             */
            entitlementsReplaceDelegates4: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/replaceAuthorizedUser`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddFulfillment
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/fulfill
             * @secure
             */
            entitlementsAddFulfillment: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/fulfill`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddFulfillment2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/fulfill
             * @secure
             */
            entitlementsAddFulfillment2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/fulfill`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeServiceArea
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeServiceArea
             * @secure
             */
            entitlementsChangeServiceArea: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeServiceArea`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeServiceArea2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeServiceArea
             * @secure
             */
            entitlementsChangeServiceArea2: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeServiceArea`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeEffectiveDates
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeEffectiveDates
             * @secure
             */
            entitlementsChangeEffectiveDates: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeEffectiveDates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeEffectiveDates2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeEffectiveDates
             * @secure
             */
            entitlementsChangeEffectiveDates2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeEffectiveDates`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddContracts
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/addContracts
             * @secure
             */
            entitlementsAddContracts: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/addContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsAddContracts2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/addContracts
             * @secure
             */
            entitlementsAddContracts2: (identityId, entitlementId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/addContracts`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeOwner
             * @summary Machine JWT Only
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/changeOwner
             * @secure
             */
            entitlementsChangeOwner: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description All modification methods require machine JWTs
             *
             * @tags Entitlements
             * @name EntitlementsChangeOwner2
             * @summary Machine JWT Only
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/changeOwner
             * @secure
             */
            entitlementsChangeOwner2: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/updateProvisioningType
             * @secure
             */
            machineJwtOnly: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/updateProvisioningType`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly2
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/updateProvisioningType
             * @secure
             */
            machineJwtOnly2: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/updateProvisioningType`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly3
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/fulfillment/setup
             * @secure
             */
            machineJwtOnly3: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/fulfillment/setup`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone has setup their entitlement
             *
             * @tags Entitlements
             * @name MachineJwtOnly4
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/fulfillment/setup
             * @secure
             */
            machineJwtOnly4: (identityId, entitlementId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/fulfillment/setup`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * @description modifies or creates an entitlement in place
             *
             * @tags Entitlements
             * @name MachineJwtOnly5
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/identities/{identityId}/entitlements/migrate
             * @secure
             */
            machineJwtOnly5: (identityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/migrate`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description modifies or creates an entitlement in place
             *
             * @tags Entitlements
             * @name MachineJwtOnly6
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/users/{identityId}/entitlements/migrate
             * @secure
             */
            machineJwtOnly6: (identityId, data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/migrate`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description indicates someone a new member number
             *
             * @tags Entitlements
             * @name MachineJwtOnly7
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/identities/{identityId}/entitlements/{entitlementId}/updateFriendlyId
             * @secure
             */
            machineJwtOnly7: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/entitlements/${entitlementId}/updateFriendlyId`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description indicates someone a new member number
             *
             * @tags Entitlements
             * @name MachineJwtOnly8
             * @summary All modification methods require machine JWTs
             * @request POST:/v1/users/{identityId}/entitlements/{entitlementId}/updateFriendlyId
             * @secure
             */
            machineJwtOnly8: (identityId, entitlementId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/users/${identityId}/entitlements/${entitlementId}/updateFriendlyId`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags EntitlementsJournal
             * @name EntitlementsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/entitlements/journal
             * @secure
             */
            entitlementsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlements/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EntitlementsJournal
             * @name EntitlementsJournalGetJournalMaxClock
             * @request GET:/v1/entitlements/journal/maxClock
             * @secure
             */
            entitlementsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlements/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description modifies or creates an entitlement in place
             *
             * @tags MigrateEntitlements
             * @name MachineJwtOnly22
             * @summary Only to be called by migration services for extraction of data
             * @request POST:/v1/entitlements/migrate
             * @secure
             */
            machineJwtOnly22: (data, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/entitlements/migrate`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=entitlements.js.map